import React from 'react';
import { useDrop } from 'react-dnd';
import PropTypes from 'prop-types';

const PathAU = ({ result, text, showRedCircle, placeOnMap }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'card',
    drop: (item) => showAnswer(item.answer),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  const showAnswer = (answer) => {
    if (answer === 'AU') {
      result(true);
      showRedCircle(true);
    } else {
      result(false);
      showRedCircle(false);
    }
  };
  let fill = '#68afad';
  if (isOver) {
    fill = '#262c2c';
  }
  return (
    <g id="AU" ref={drop} fill={fill} className="australia">
      <path
        stroke="#000"
        d="M872.89 395.44c-.33.05-.36.27-.1.69.41.67-.57 2.09-2.17 3.14-1.61 1.05-2.66 2.33-2.35 2.82.3.5-.24 1.56-1.2 2.35-1.25 1.04-1.39 1.82-.5 2.89.67.82.83 1.75.32 2.06-1.83 1.14-8.91-.1-9.54-1.66-.91-2.24-3.55-2.53-3.55-.4 0 .97-1.24 2.34-2.78 3.04-1.59.72-2.58 1.91-2.24 2.78.32.85.22 2.17-.25 2.93-.62 1.01-1.3.82-2.43-.72-1.5-2.06-1.56-2.06-1.7.11-.07 1.23-.05 2.86.04 3.61.18 1.43-6.83 7.31-8.71 7.31-1.14 0-6.44 2.67-12.87 6.47-4.23 2.5-4.98 6.45-1.88 9.87 1.13 1.26 1.57 2.9 1.08 4.16-.76 1.95-.9 1.94-2.46-.18-.95-1.3-1.66-1.62-1.66-.76 0 .82 1.08 3.04 2.42 4.91 2.7 3.8 6.16 18.4 5.35 22.64-.4 2.1.25 3.12 2.82 4.44 3.12 1.62 3.6 1.55 7.63-1.19 2.4-1.63 5.95-2.93 8.03-2.93 2.36 0 4.85-1.05 6.83-2.89 1.72-1.59 4.46-2.89 6.07-2.89 1.62 0 4.52-.56 6.48-1.23 5.34-1.83 14.34 1.78 16.77 6.72 1.01 2.05 2.1 3.71 2.46 3.73.36.01 1.57-1.88 2.68-4.2 1.48-3.11 2.33-3.88 3.29-2.93.95.96.96 2.11-.04 4.31-1.78 3.9-1.73 4.58.25 2.93 1.19-.99 1.84-.98 2.43-.04.43.71.5 1.59.14 1.95-.36.37.63 2.18 2.21 4.05 1.57 1.87 2.85 4.14 2.85 5.03 0 2.52 7.12 4.01 9.47 1.99 1.7-1.47 2.19-1.39 4.05.65 2.73 2.97 2.54 2.99 5.17-.37 1.33-1.68 3.25-2.75 4.67-2.6 1.65.18 2.51-.47 2.71-2.06.37-2.92 2.51-9.06 5.24-15.04 2.73-5.97 5.62-29.78 3.54-29.18-1.09.32-7.08-3.93-7.08-5.02 0-.53-1.28-2.35-2.86-4.05-1.58-1.71-2.63-3.54-2.31-4.05.31-.51-.48-1.25-1.77-1.66-3.18-1.01-6.94-8.74-6.94-14.25 0-2.98-.76-5.16-2.25-6.51-1.23-1.12-2.6-3.67-3.03-5.67-.43-2.01-1.06-4.14-1.41-4.74-.88-1.47-3.51 5.99-3.66 10.34-.11 3.5-4 13.31-5.27 13.31-.38 0-3.54-2.11-7.05-4.7-5.97-4.41-6.37-4.96-5.64-8.39.42-2.02 1.23-4.17 1.8-4.77 1.37-1.46 1.34-4.44-.03-3.58-.59.36-1.36.17-1.74-.44-.37-.6-1.61-1.04-2.71-.97-1.1.06-3.22-.3-4.74-.8-.92-.3-1.55-.42-1.88-.36z"
      ></path>
      <path
        stroke="#000"
        d="M885.44 480.08c-.17.02-.36.09-.51.18-.6.37-.77 1.17-.39 1.77.37.6 1.16.77 1.77.4.6-.37.77-1.17.4-1.77-.28-.46-.77-.66-1.27-.58z"
      ></path>
      {text === 'Austrálie' && placeOnMap === true ? (
        <ellipse
          stroke="#000"
          ry="29.54544"
          rx="30.84412"
          id="svg_1"
          cy="442.27213"
          cx="878.66901"
          fill="#eb5e55"
        />
      ) : null}
    </g>
  );
};

PathAU.propTypes = {
  result: PropTypes.func,
  text: PropTypes.string,
  showRedCircle: PropTypes.func,
  placeOnMap: PropTypes.bool,
};
export default PathAU;
